import React, { Component} from 'react';
import './Criatura.css';

import petops from './img/petops.png';
import idle0 from './img/idle0.svg';
import idle1 from './img/idle1.svg';
import idle2 from './img/idle2.svg';
import huevo0 from './img/cd0.png';
import huevo00 from './img/cd1.png';
import huevoC1 from './img/cd2.png';
import huevoC2 from './img/cd3.png';
import huevoC3 from './img/cd4.png';
import huevoC4 from './img/cd5.png';
import huevoC5 from './img/cd6.png';
import huevoC6 from './img/cd7.png';
import huevoC7 from './img/cd8.png';
import angry0 from './img/angry.svg';
import angry1 from './img/angry1.svg';
import angry2 from './img/angry2.svg';
import angry3 from './img/angry3.svg';
import moneda from './img/moneda.png'
import botonMenu from './img/menu.png'
import iconoFelicidad from './img/storage.png';
import iconowordpress from './img/security.png';
import iconoCorazon from './img/networking2.png';
import iconoManzana from './img/services2.png';
import flecha from './img/back.png';
import comida1 from './img/tomcat.png';
import comida2 from './img/printer.png';
import comida3 from './img/samba.png';
import salud1 from './img/mail.png';
import salud2 from './img/dns.png';
import salud3 from './img/proxy.png';
import dedo1 from './img/wordpress.png';
import dedo2 from './img/kernel.png';
import dedo3 from './img/openssl.png';
import diversion1 from './img/replace.png';
import diversion2 from './img/devnull.png';
import diversion3 from './img/backup.png';
import llorar0 from './img/sad0.svg';
import llorar1 from './img/sad1.svg';
import llorar2 from './img/sad2.svg';
import llorar3 from './img/sad3.svg';
import llorar4 from './img/sad4.svg';
import diskfail0 from './img/diskfail0.svg';
import diskfail1 from './img/diskfail1.svg';
import ocho from './img/8.svg';
import ochoocho from './img/88.svg';
import ochoochoocho from './img/888.svg';
import ochoochoochoocho from './img/8888.svg';
import excited0 from './img/excited0.svg';
import excited1 from './img/excited1.svg';
import storage0 from './img/diskok0.svg';
import storage1 from './img/diskok1.svg';
import storage2 from './img/diskok0.svg';
import storage3 from './img/diskok1.svg';
import storage4 from './img/diskok0.svg';

import fixing0 from './img/fixing0.svg';
import fixing1 from './img/fixing1.svg';
import fixing2 from './img/fixing2.svg';



const velAnimacion = 250;  //ms
const probNacimiento = .8;
var menuAbierto = false;
var gameOver = false;
var puntuacion = 0;
var printerTimes = 0;
var output = "";
let petnumber = 1;

const styleImg = {
  /*height: '31.35vh',*/
  height: '100vh',
  width: 55,
  padding: '4vh',
}


//Bucle
let cont = 0;
if(gameOver==false){
  setInterval(() => {
    cont++;
  }, velAnimacion);
}



class Criatura extends Component {
    constructor(props){
      super(props)
      this.state = {
        cont: 0,
        contIdle: 0,
        mensajeInicial: <p>Booting up your new Pet Server<br />Happy SysAdmin Day!</p>,
        nombre: "root@PetServer001:~#",

        backup: Math.floor(Math.random() * 31) + 50,
        tam: 0,
        tamPlus: 0,
        replace: 30,
        mail: Math.floor(Math.random() * 31) + 50,

        diskspace: 73,
        dns: 50,
        proxy: 50,
        tomcat: 30,
        printers: Math.floor(Math.random() * 31) + 50,
        wordpress: Math.floor(Math.random() * 31) + 50,
        samba: Math.floor(Math.random() * 31) + 50,
        
        accion: "Booting...", //Booting.../Idle
        animList: [],
        anim: 0,
        img: huevo0,
        idMenu: 0,
        money: 10,
      }

      if(gameOver== false){
        setInterval(() => { 

         //console.log(["Tamaño: "+parseInt(this.state.tam),"diskspace: "+parseInt(this.state.diskspace),"printers: "+parseInt(this.state.printers),
         //"tomcat: "+parseInt(this.state.tomcat), "replace: "+parseInt(this.state.replace), "mail: "+parseInt(this.state.mail), "dns: "+parseInt(this.state.dns),
         //"proxy: "+parseInt(this.state.proxy),"wordpress: "+parseInt(this.state.wordpress),"samba: "+parseInt(this.state.samba),"backup: "+parseInt(this.state.backup)]);
          
          this.setState({ 
            cont: cont,
            money: this.state.accion == "Idle" ? this.state.money+0.02:this.state.money+0.0005,
  
            //Minimos y maximos + cambios constantes
            tam: this.state.tam<0 ? 0: this.state.tam>70 ? 70:this.state.tamPlus+(this.state.backup/100),
            backup: this.state.backup<0 ? 0: this.state.backup+0.05,
            replace: this.state.replace<0 ? 0: this.state.replace>100 ? 100:this.state.replace+0.05,
            mail: this.state.mail<0 ? 0: this.state.mail>100 ? 100:this.state.mail+0.05,
            diskspace: this.state.diskspace<0 ? 0:this.state.diskspace>100 ? 100: this.state.diskspace+0.03,
            dns: this.state.dns<0 ? 0:this.state.dns>100 ? 100: this.state.dns+0.3,
            proxy: this.state.proxy<0 ? 0:this.state.proxy>100 ? 100:this.state.proxy+0.15,
            samba: this.state.samba<0 ? 0:this.state.samba>100 ? 100: this.state.samba+0.4,
            wordpress: this.state.wordpress<0 ? 0:this.state.wordpress>100 ? 100: this.state.wordpress+0.1,
            tomcat: this.state.tomcat<0 ? 0:this.state.tomcat>100 ? 100: this.state.tomcat+0.2,
            printers: this.state.printers<0 ? 0:this.state.printers>100 ? 100:this.state.accion == "Running cron jobs" ? this.state.printers-0.001:this.state.printers+0.01,
            //samba: this.state.samba<0 ? 0:this.state.samba>100 ? 100:this.state.accion == "Updating software repositories" && this.state.anim == this.state.animList.length-1 ? 0: this.state.samba,
            //wordpress: this.state.wordpress>100 ? 100 : this.state.wordpress<0 ? 0: this.state.accion == "Upgrading WordPress" ? this.state.wordpress>20 ? this.state.wordpress-3 : this.state.wordpress+(this.state.replace/100)+0.05 : this.state.wordpress+(this.state.replace/100)+0.05,
  
          }); 
        }, velAnimacion);

  

        
      }
      
   
    }
    reiniciar(){
      ++petnumber;
      this.setState({ 
        cont: 0,
        contIdle: 0,
        mensajeInicial: <p>Booting up a new Pet Server<br />Happy SysAdmin Day!</p>,
        nombre: "root@PetServer002:~#",
        backup: 0,
        tam: 0,
        tamPlus: 0,
        replace: 0,
        mail: 0,
        diskspace: 70,
        dns: 70,
        proxy: 70,
        tomcat: 70,
        printers: 70,
        wordpress: 70,
        samba: 70, 
        accion: "Booting...",
        animList: [],
        anim: 0,
        img: huevo0,
        idMenu: 0,
        money: 10,
      })
      menuAbierto = false;
      gameOver = false;
      puntuacion = 0;


    }
    render() {
      var tweet = "https://twitter.com/intent/tweet?text=Do you treat your servers as pets or as cattle? Play %23PetOps on https://sysarmy.com/petops %23SysAdminDay /via @sysarmy";
      if(this.state.money < 1 && this.state.accion != "Idle" && this.state.accion != "Running cron jobs"){ gameOver=true;}
      if(this.state.accion=="Idle"){this.state.contIdle++;}
      if (this.state.contIdle > 50){puntuacion+=2; this.state.contIdle=0;}

      return (

        <div className="Criatura">

          {gameOver && <this.GameOver />} 
          {(menuAbierto && gameOver==false) && 
            <nav className = "menu-options">
              <button onClick={()=>{menuAbierto=!menuAbierto;}} className="boton-menuP botonSuperior abierto">
                  <img src={botonMenu} style={{alignSelf: 'flex-end'}}></img>
              </button>
              <img src={petops} class="petops"></img>
              <p class="preface">
                Remember when System Administration was a craft?<br /><br />Get to relive simpler times,<br />when each server was like your own pet. Happy SysAdmin Day!
              </p>
              <div className="opc">
                <p>Game options:</p>
                <button onClick={()=>{this.reiniciar()}} className="boton-menuP abierto">Reboot</button>
                <button onClick={()=>{menuAbierto=!menuAbierto;}} className="boton-menuP abierto">Save</button>
                <button onClick={()=>{menuAbierto=!menuAbierto;}} className="boton-menuP abierto">Continue</button>
                <br />
                <a href={tweet} class="twitter-share-button" data-show-count="false"><i></i><span class="label" id="l">Tweet</span></a><script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>
              </div>
              <div class="credits">
                <ul class="list">
                 <li>Based on <a href="https://github.com/OscarEstudioSKR/React-Maskotin">React-Maskotin</a> by Oscar Aparisi Sancho.</li>
                 <li>Server illustrations by <a href="https://www.behance.net/ahilustraciones">Alana Haffar</a>.</li>
                 <li><a href="https://www.iconfinder.com/iconsets/kids">Kids Icons</a> from KDE 3 by Everaldo.</li>
                </ul>
              </div>
            </nav>
          }
          <header>
              
            <div>
            <img src={moneda} class="coin"></img>
              {this.state.money<4 ? <p className="parpadeo fijo">{Math.floor(this.state.money)}</p>: 
              this.state.accion=="Idle" ? <p className="subidon fijo">{Math.floor(this.state.money)}</p>:<p className="fijo">{Math.floor(this.state.money)}</p>}
            </div>
            <div>
              <p>Uptime: {Math.floor(puntuacion)}</p>
            </div>  
            <button onClick={()=>{menuAbierto=!menuAbierto;}} className="boton-menuP">
              <img src={botonMenu}></img>
            </button>
          </header>

          <fondo><this.Animar /></fondo>
          <h2>{this.state.accion}</h2> 
          <footer>
            {this.state.navAbierto ? <this.Navegador />:this.state.mensajeInicial}
          </footer>
               
      </div>
      );
    }
    GameOver = ()=>{
      gameOver = true;
      var tweet = "https://twitter.com/intent/tweet?text=Do you treat your servers as pets or as cattle? Play %23PetOps on https://sysarmy.com/petops %23SysAdminDay /via @sysarmy";
      return(
        <div className="GameOver">
          <h2>Game Over</h2>
          <p><b>Uptime: {puntuacion}</b><br /><br />
          Maintaining servers is a craft, which is often undervalued.<br /><br />
          Thank you for all your hard work and happy SysAdmins Day!<br /><br />
          <br />
            <a href={tweet} class="twitter-share-buttong" data-show-count="false"><i></i><span class="labelg">Tweet</span></a><script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>
</p>
          <button onClick={()=>this.reiniciar()}>New Pet Server</button>
        </div>
        
      );
    }

    Navegador = ()=>{
      return(
        <div>
          <this.BotonNav pos = "1"/>
          <this.BotonNav pos = "2" />
          <this.BotonNav pos = "3" />
          <this.BotonNav pos = "4" />     
        </div>
      )
    }

    BotonNav = (props)=> {
      let m = this.state.money;
      let pos = props.pos;
      let imaBoton = iconoFelicidad;
      var fun = "";
      let gastar = ()=> {
        this.state.money --;
        puntuacion += 5;}


      if(this.state.idMenu == 0){
        if(pos==1){imaBoton = iconoFelicidad;}
        if(pos==2){imaBoton = iconoCorazon;}
        if(pos==3){imaBoton = iconoManzana;}
        if(pos==4){imaBoton = iconowordpress;} 
        return <button className="botonAccion" onClick={()=>this.state.idMenu=pos}><img src={imaBoton}className="imaBoton"></img></button> 
      }

      if(this.state.idMenu == 1){
        if(pos==1){imaBoton = flecha; fun = ()=> this.state.idMenu=0;}
        if(pos==4){imaBoton = diversion1; fun = ()=> m > 1 ? (gastar(), ejecutarAccion("storage")):false}
        if(pos==3){imaBoton = diversion2; fun = ()=> m > 1 ? (gastar(),ejecutarAccion("Devnull")):false}
        if(pos==2){imaBoton = diversion3; fun = ()=> m > 1 ? (gastar(), ejecutarAccion("Backup")):false}      
      }
      if(this.state.idMenu == 2){
        if(pos==1){imaBoton = flecha; fun = ()=> this.state.idMenu=0;}
        if(pos==2){imaBoton = salud1; fun = ()=> m > 1 ? (gastar(), ejecutarAccion("Mail")):false}
        if(pos==3){imaBoton = salud2; fun = ()=> m > 1 ? (gastar(), ejecutarAccion("DNS")):false}
        if(pos==4){imaBoton = salud3; fun = ()=> m > 1 ? (gastar(), ejecutarAccion("Proxy")):false} 
      }
      if(this.state.idMenu == 3){
        if(pos==1){imaBoton = flecha; fun = ()=> this.state.idMenu=0;}
        if(pos==2){imaBoton = comida1; fun = ()=> m > 1 ? (gastar(), ejecutarAccion("Tomcat")):false}
        if(pos==3){imaBoton = comida2; fun = ()=> m > 1 ? (gastar(), ejecutarAccion("Printer")):false}
        if(pos==4){imaBoton = comida3; fun = ()=> m > 1 ? (gastar(), ejecutarAccion("Samba")):false}  
      }
      if(this.state.idMenu == 4){
        if(pos==1){imaBoton = flecha; fun = ()=> this.state.idMenu=0;}
        if(pos==2){imaBoton = dedo1; fun = ()=> m > 1 ? (gastar(), ejecutarAccion("Upgrading WordPress")):false}
        if(pos==3){imaBoton = dedo2; fun = ()=> m > 1 ? (gastar(), ejecutarAccion("Recompiling kernel")):false}
        if(pos==4){imaBoton = dedo3; fun = ()=> m > 1 ? (gastar(), ejecutarAccion("Updating OpenSSL")):false}  
      }

      var ejecutarAccion2 = (accionT, arrT) => {
        this.setState({
          accion: accionT,
          animList: arrT,
          navAbierto: false,
          anim:0,
        })
      }

      let ejecutarAccion = (tipo) => {
       
        if(tipo == "Devnull"){
          ejecutarAccion2("rm -rf /tmp/*",[storage0,storage0,storage1,storage2,storage3,storage4,storage0,storage0,storage1,storage2,storage3,storage4,storage0,storage0,storage1,storage2,storage3,storage4,storage0,storage0]);
          this.setState({
            mensajeInicial: <p>Finding a more permanent location for temp files</p>,
            tamPlus: this.state.tamPlus+0.1,
            diskspace: this.state.diskspace-20,
            dns: this.state.dns-25,
            proxy: this.state.proxy+2,
            replace: this.state.replace+30,
            tomcat: this.state.tomcat-20,
            printers: this.state.printers+5,
            wordpress: this.state.wordpress+15,
            samba: this.state.samba+20,
          })
        }
        if(tipo == "DNS"){
          ejecutarAccion2("Restarting DNS Server",[ocho,ocho,ochoocho,ochoocho,ochoochoocho,ochoochoocho,ochoochoochoocho,ochoochoochoocho]);
          this.setState({
            mensajeInicial: <p>There's not way it's the DNS. It was the DNS!</p>,
            tamPlus: this.state.tamPlus+0.1,
            diskspace: this.state.diskspace+10,
            dns: this.state.dns-20,
            proxy: this.state.proxy+15,
            replace: this.state.mail+15,
            wordpress: this.state.wordpress+5,
            samba: this.state.samba+15,
          })
        }
        if(tipo == "Mail"){
          ejecutarAccion2("Flushing mail queue",[fixing0,fixing1,fixing2,fixing1,fixing0,fixing1,fixing2,fixing1,fixing0,fixing1,fixing2,fixing1,fixing0,fixing1,fixing2,fixing1,fixing0]);
          this.setState({
            mensajeInicial: <p>Maybe that was the reason the CEO didn't get that email!</p>,
            backup: this.state.backup+20,
            diskspace: this.state.diskspace+10,
            proxy: this.state.proxy+5,
            replace: this.state.replace+15,
            tomcat: this.state.tomcat-20,
            printers: this.state.printers+15,
            samba: this.state.samba-20,
            wordpress: this.state.wordpress+5
          })
        }
        if(tipo == "storage"){
          ejecutarAccion2("Replacing WD Green disk",[storage0,storage0,storage1,storage2,storage3,storage4,storage0,storage0,storage1,storage2,storage3,storage4,storage0,storage0,storage1,storage2,storage3,storage4,storage0,storage0]);
          this.setState({       
            mensajeInicial: <p>Don't be cheap on<br />your hardware!</p>,
            diskspace: this.state.diskspace-10,
            dns: this.state.wordpress+10,
            proxy: this.state.proxy+1,
            replace: this.state.replace-20,
            wordpress: this.state.wordpress+20,
            samba: this.state.samba+15,
          })
          this.state.money -=2.5;
        }
        if(tipo == "Backup"){
          ejecutarAccion2("Backing up important data",[storage0,storage0,storage1,storage2,storage3,storage4,storage0,storage0,storage1,storage2,storage3,storage4,storage0,storage0,storage1,storage2,storage3,storage4,storage0,storage0]);
          this.setState({
            mensajeInicial: <p>Always remember to test your backups!!</p>,
            tamPlus: this.state.tamPlus+0.05,
            diskspace: this.state.diskspace+15,
            dns: this.state.dns+25,
            proxy: this.state.proxy+15,
            replace: this.state.replace+20,
            tomcat: this.state.samba+10,
            printers: this.state.printers+10,
            mail: this.state.mail+5,
            wordpress: this.state.wordpress+15,
            backup: this.state.wordpress-15,
            samba: this.state.samba+10
          })
          this.state.money -=0.5;
        }
        if(tipo == "Proxy"){
          ejecutarAccion2("Restarting proxy server",[storage0,storage0,storage0,storage0,storage0,storage0]);
          this.setState({
            mensajeInicial: <p>Be careful with your browsing habits, everything gets logged!</p>,
            backup: this.state.backup+5,
            tamPlus: this.state.tamPlus+0.2,
            diskspace: this.state.diskspace+15,
            dns: this.state.dns+25,
            proxy: this.state.proxy-25,
            printers: this.state.printers+10,
            mail: this.state.mail+5,
            wordpress: this.state.wordpress+20,
            tomcat: this.state.tomcat-20,
            samba: this.state.samba+30
          })
          this.state.money -=0.5;
        }
        
        if(tipo == "Tomcat"){
          ejecutarAccion2("Restarting Tomcat Server",[fixing0,fixing1,fixing2,fixing1,fixing0,fixing1,fixing2,fixing1,fixing0,fixing1,fixing2,fixing1,fixing0,fixing1,fixing2,fixing1,fixing0]);
          this.setState({
            mensajeInicial: <p>You can never bounce it enough times</p>,
            tamPlus: this.state.tamPlus+0.3,
            diskspace: this.state.diskspace+10,
            dns: this.state.dns-5,
            proxy: this.state.proxy-5,
            replace: this.state.replace+10,
            wordpress: this.state.wordpress+10,
            samba: this.state.samba+25,
            mail: this.state.mail-10,
            tomcat: this.state.tomcat-30
          })
        }
        if(tipo == "Printer"){
          printerTimes +=1;
          ejecutarAccion2("Restarting CUPS Server",[fixing0,fixing1,fixing2,fixing1,fixing0,fixing1,fixing2,fixing1,fixing0,fixing1,fixing2,fixing1,fixing0,fixing1,fixing2,fixing1,fixing0]);
          //console.log(printerTimes);
          output = "Beware! Printers are SysAdmin's natural predators!";
          if (printerTimes > 1) {
            output = "Maybe the printer is down because the network is down";
            printerTimes = 0;
          } 
          this.setState({
            mensajeInicial: <p>{output}</p>,
            backup: this.state.backup+0.02,
            diskspace: this.state.diskspace-2,
            dns: this.state.dns+5,
            proxy: this.state.proxy+5,
            replace: this.state.replace+1,
            tomcat: this.state.tomcat+5,
            printers: this.state.printers-20,
            samba: this.state.samba+20,
          })
          this.state.money -=0.5;
        }
        if(tipo == "Samba"){
          ejecutarAccion2("Fixing Samba permissions",[fixing0,fixing1,fixing2,fixing1,fixing0,fixing1,fixing2,fixing1,fixing0,fixing1,fixing2,fixing1,fixing0,fixing1,fixing2,fixing1,fixing0]);
          this.setState({
            mensajeInicial: <p>Turns out all users had root privileges!</p>,
            backup: this.state.backup+20,
            diskspace: this.state.diskspace+10,
            proxy: this.state.proxy+5,
            replace: this.state.replace+15,
            tomcat: this.state.tomcat-20,
            printers: this.state.printers+15,
            samba: this.state.samba-20,
            wordpress: this.state.wordpress+5
          })
        }

        if(tipo == "Upgrading WordPress"){
          ejecutarAccion2("Upgrading WordPress",[fixing0,fixing1,fixing2,fixing1,fixing0,fixing1,fixing2,fixing1,fixing0,fixing1,fixing2,fixing1,fixing0,fixing1,fixing2,fixing1,fixing0]);
          this.setState({mensajeInicial: <p>A new release is ready and you should update immediately.</p>});
          this.setState({
            
            dns: this.state.dns+5,
            proxy: this.state.proxy+5,
            tomcat: this.state.tomcat-5,
            mail: this.state.mail+0.1,
            wordpress: this.state.wordpress-40,
            samba: this.state.samba+2,
          })
        }

        if(tipo == "Recompiling kernel"){
          ejecutarAccion2("Recompiling kernel",[fixing0,fixing1,fixing2,fixing1,fixing0,fixing1,fixing2,fixing1,fixing0,fixing1,fixing2,fixing1,fixing0,fixing1,fixing2,fixing1,fixing0]);
          this.setState({
            mensajeInicial: <p>make bzImage && make modules && make modules_install</p>,
            backup: this.state.backup+1,
            tamPlus: this.state.tamPlus-0.1,
            diskspace: this.state.diskspace+60,
            dns: this.state.dns+15,
            proxy: this.state.proxy+10,
            replace: this.state.replace+20,
            tomcat: this.state.tomcat-10,
            printers: this.state.printers-10,
            mail: this.state.mail-5,
            wordpress: this.state.wordpress-10,
            samba: this.state.samba-5,
          })
        }
        if(tipo == "Updating OpenSSL"){
          ejecutarAccion2("Updating OpenSSL",[fixing0,fixing1,fixing2,fixing1,fixing0,fixing1,fixing2,fixing1,fixing0,fixing1,fixing2,fixing1,fixing0,fixing1,fixing2,fixing1,fixing0]);
          this.setState({
            mensajeInicial: <p>Always keep your software up to date!</p>,
            dns: this.state.dns+15,
            proxy: this.state.proxy+20,
            diskspace: this.state.diskspace-5,
            replace: this.state.replace+20,
            tomcat: this.state.tomcat+20,
          })
          this.state.money -=0.2;
        }


      }

      return <button className="botonAccion" onClick={fun}><img src={imaBoton}className="imaBoton"></img></button>
     }
    

    Animar = ()=>{

      if(this.state.accion == "Disabling SELinux..." && this.state.anim == this.state.animList.length-1) {
        this.state.accion = "Idle";
        this.state.anim=0;
      }  
  
      if(this.state.anim<this.state.animList.length-1){ this.state.anim ++;
      }else if(this.state.accion == "Obtaining IP address..." && this.state.anim == this.state.animList.length-1){
        this.state.animList=[idle0];
        this.state.anim=0;
        this.state.accion = "Disabling SELinux...";
        this.state.navAbierto = true;
        }else{this.state.anim = 0;}
  
      if(this.state.accion == "Booting..."){
        this.state.animList= [huevo0];
        if(this.state.cont > 10){
          this.state.accion = "Running LILO";
          this.state.anim=0;
        }
      }
      if(this.state.accion == "Running LILO"){
        this.state.animList= [huevo0,huevo00];

        if(this.state.cont > 20){
          if(Math.random()>probNacimiento){
            this.state.accion = "Obtaining IP address...";
            this.state.anim=0;
          }else {
            this.state.accion = "Booting...";
          }
        }
        
      }else if(this.state.accion == "Obtaining IP address..."){
        this.state.animList= [huevoC1,huevoC2,huevoC3,huevoC4,huevoC5,huevoC6,huevoC7,huevoC1,huevoC2,huevoC3,huevoC4,huevoC5,huevoC6,huevoC7,huevoC1,huevoC2,huevoC3,huevoC4];

      }else if(this.state.accion == "Disabling SELinux..."){
        this.state.animList=[idle0,idle1,idle2];


      }else if(this.state.navAbierto==true){

        //Añadir estados
        
        if(this.state.accion != "Running cron jobs"){
          if(this.state.wordpress>=99){ this.state.dns =60; this.state.proxy =50; this.state.wordpress =50;this.cambioAccion("Updating software repositories", [excited0,excited0,excited1,excited1,excited0,excited0]);}
          else if(this.state.diskspace>=75){ this.cambioAccion("Disk space running low", [diskfail0,diskfail1]);}
          else if(this.state.replace>=90){ this.cambioAccion("RAID-1 disk failure", [diskfail0,diskfail1]);}
          else if(this.state.tomcat>=75 && this.state.tomcat<=84 ){ this.cambioAccion("CPU Load 100%", [angry0,angry1,angry2,angry3]);} 
          else if(this.state.tomcat>=85){ this.cambioAccion("Core 0 temperature HIGH", [angry0,angry1,angry2,angry3]);}
          else if(this.state.wordpress>=85){ this.cambioAccion("Upgrading WordPress", [angry0,angry1,angry2,angry3]);}
          else if(this.state.printers>=75){ this.cambioAccion("CFO says the printer is not working", [angry0,angry0,angry1,angry1,angry0,angry0]);}
          else if(parseInt(this.state.tam) % 2 == 1){ this.cambioAccion("Running cron jobs", [angry0,angry0,angry1,angry1,angry0,angry0]);}
          else if(this.state.dns>=70 || this.state.proxy>=70){ this.cambioAccion("Cannot reach google.com", [ocho,ocho,ochoocho,ochoocho,ochoochoocho,ochoochoocho,ochoochoochoocho,ochoochoochoocho]);}
          else if(parseInt(this.state.proxy) % 2 ==0){ this.cambioAccion("New security bug found", [llorar0,llorar1,llorar0,llorar1,llorar0,llorar1,llorar0,llorar1,llorar0,llorar2,llorar3,llorar4]);}      
        }

        //Quitar estados
        if(this.state.tomcat>20 && this.state.accion=="Running cron jobs"){  this.cambioAccion();}
        else if(this.state.tomcat>20 && this.state.accion=="Upgrading WordPress"){ this.cambioAccion();}
        else if(this.state.printers<50 && this.state.accion=="CFO says the printer is not working"){ this.cambioAccion();}
        else if(this.state.diskspace<70 && this.state.accion=="Disk space running low"){ this.cambioAccion();}
        else if(this.state.replace<50 && this.state.accion=="RAID-1 disk failure"){ this.cambioAccion();}
        else if(this.state.dns<50 && this.state.accion=="Core 0 temperature HIGH"){  this.cambioAccion();}
        else if(this.state.wordpress<80 && this.state.accion=="New security bug found"){  this.cambioAccion();}
        else if(this.state.tomcat<70 && this.state.accion=="CPU Load 100%"){  this.cambioAccion();}
        else if(this.state.dns<50 && this.state.accion=="Cannot reach google.com"){  this.cambioAccion();}
        else if(this.state.samba<50 && this.state.accion=="Updating software repositories"){  this.cambioAccion();}
      }

      //Acciones que bloquean la pantalla
      let a = this.state.accion;
      if((a=="Restarting Tomcat Server" || a=="Fixing Samba permissions"|| a=="Restarting CUPS Server" || a=="Restarting proxy server"
      || a=="Replacing WD Green disk" || a=="Flushing mail queue" || a=="Backing up important data" || a=="rm -rf /tmp/*" || a=="New device plugged in but driver is not available" || a=="Recompiling kernel" || a=="Upgrading WordPress" || a=="Updating OpenSSL"|| a=="Comunicándose" || a=="Restarting DNS Server")
      && this.state.anim == this.state.animList.length-1){ this.state.navAbierto=true; this.cambioAccion();this.state.anim=0; }

      this.state.img= this.state.animList[this.state.anim];
      return <img  style={{width: styleImg.width*(1+((this.state.tam/100)))+"%", padding: styleImg.padding, margin: (-((7*this.state.tam)/100))+"vh"}} src={this.state.img} alt= {this.state.accion} />
      
    }

    cambioAccion (tipo="Idle",arr=[idle0,idle1,idle0,idle1,idle2]){
      if(this.state.anim > arr.length-1){this.state.anim =  0;}
      this.state.accion = tipo;
      this.state.animList= arr;
    }

  }

export default Criatura;